import { apiError } from "../../lib/apiError";
import httpClient from "../../lib/httpClient";
import { filterModelToQueryValue } from "./tableUtils";

export const getMapComuneData = async (props) => {
  const queryValue = filterModelToQueryValue(props.filterModel);

  let getParameters;
  if (props.variant === "ClimateAnalytics" || props.variant === "AgroClimateAnalytics") {
    const kpiToUse = props.variant === "ClimateAnalytics" ? "accruedRisk" : "policyNumber";
    const load = {
      refDate: props.wantedReferenceDate,
      aggr: "OverallMap",
      filters: filterModelToQueryValue(props.filterModel),
      hazardSelect: "anyhazard",
      KPISelect: kpiToUse,
    };

    const postUrl =
      props.variant === "AgroClimateAnalytics"
        ? "proxy/agroanalytics_reale"
        : "analyticFilter/plainFilterPost";

    try {
      const res = await httpClient().post(postUrl, load);

      if (!res.data || !res.data.mapComuneIstatNumberToKPIValue) {
        console.log("Unexpected response from map data:", res.data, " request:", getParameters);
        props.setFilteredMapData(null);
      } else {
        props.setFilteredMapData(res.data);
      }
    } catch (err) {
      apiError(err);
      console.log(err);
    }
  } else {
    getParameters = `/mapData?entities=${props.routeName}&filters=${queryValue}`;
    try {
      const res = await httpClient().get(getParameters);

      if (!res.data || !res.data.mapComuneIstatNumberToKPIValue) {
        console.log("Unexpected response from map data:", res.data, " request:", getParameters);
        props.setFilteredMapData(null);
      } else {
        props.setFilteredMapData(res.data);
      }
    } catch (err) {
      console.log(err);
    }
  }
};

export const seismicGreenShades = [
  "#f7fcf5",
  "#ddf2d7",
  "#b2e0ab",
  "#7bc77c",
  "#3da759",
  "#237e3a",
  "#0f451a",
];
